export function OutlinePermisionarioIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9983 15.998H19.003C20.107 15.998 20.9998 16.8908 20.9998 17.9948V20.9996H11.0015V17.9948C11.0015 16.8908 11.8943 15.998 12.9983 15.998Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9985 5.00195H12.9985V8.00195H18.9985V5.00195Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9984 8.00195H10.9968"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9985 9.99875C18.9985 11.6547 17.6545 12.9987 15.9985 12.9987C14.3425 12.9987 12.9985 11.6547 12.9985 9.99875C12.9985 9.23075 13.2865 8.52995 13.7617 8.00195H18.2353C18.7105 8.52995 18.9985 9.23075 18.9985 9.99875Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 3H8.99999"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 8.00195H6.99839"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 12.998H8.99999"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
